import { IAccessoryItem, ICostSummaryItem } from '../../CartContext.types';

export const generateAccessoryCosts = (accessory: IAccessoryItem): ICostSummaryItem => {
    const name =
        accessory.quantity === 1
            ? accessory.product.baseInfo.name
            : `${accessory.product.baseInfo.name} x${accessory.quantity}`;

    return {
        lineNumber: 0,
        itemName: name,
        amount: (accessory.productSku?.sku.price ?? 0) * accessory.quantity,
        type: 'cost'
    };
};
